/** Seeded uplift lookup — matches V2 scoring doc examples. */

export interface UpliftLookupRule {
	minEffectiveAddedObs: number;
	minRatio: number;
	uplift: number;
}

/** Ordered highest uplift first for evaluation. */
export const DEFAULT_UPLIFT_LOOKUP_RULES: UpliftLookupRule[] = [
	{ minEffectiveAddedObs: 12, minRatio: 0.8, uplift: 4 },
	{ minEffectiveAddedObs: 9, minRatio: 0.8, uplift: 3 },
	{ minEffectiveAddedObs: 6, minRatio: 0.8, uplift: 2 },
	{ minEffectiveAddedObs: 3, minRatio: 0.8, uplift: 1 },
	{ minEffectiveAddedObs: 0, minRatio: 0, uplift: 0 },
];

export function resolveUplift(
	effectiveAdded: number,
	ineffectiveAdded: number,
	rules: UpliftLookupRule[] = DEFAULT_UPLIFT_LOOKUP_RULES,
): number {
	const total = effectiveAdded + ineffectiveAdded;
	if (total === 0) return 0;
	const ratio = effectiveAdded / total;
	for (const rule of rules) {
		if (effectiveAdded >= rule.minEffectiveAddedObs && ratio >= rule.minRatio) {
			return rule.uplift;
		}
	}
	return 0;
}
